import React, { useEffect, useRef } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import ReactQuill from 'react-quill';
import { Box } from '@mui/material';

interface Props {
  value: any;
}

export const ReadOnlyQuill = ({ value }: Props) => {
  const classes = useStyles();
  const quillRef = useRef<ReactQuill>(null);

  useEffect(() => {
    if (quillRef.current) {
      quillRef.current.getEditor().root.style.padding = '0px';
    }
  }, [value]);

  return (
    <Box className={classes.root}>
      <ReactQuill ref={quillRef} value={value} theme="bubble" readOnly />
    </Box>
  );
};

const useStyles = makeStyles({
  root: {
    '& .ql-tooltip.ql-hidden': {
      display: 'none',
    },
    '& .ql-container': {
      height: 'auto',
    },
    '& .ql-editor': {
      padding: 0,
      height: 'auto',
      overflow: 'visible',
    },
  },
});
